import { Injectable, inject } from '@angular/core';
import { select, Store, Action } from '@ngrx/store';

import * as MyOrganizationActions from './my-organization.actions';
import * as MyOrganizationFeature from './my-organization.reducer';
import * as MyOrganizationSelectors from './my-organization.selectors';

@Injectable()
export class MyOrganizationFacade {
  private readonly store = inject(Store);

  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  usersList$ = this.store.pipe(select(MyOrganizationSelectors.GetUsersList));
  manageTeamsList$ = this.store.pipe(select(MyOrganizationSelectors.GetManageTeams));
  projectWorkflowList$ = this.store.pipe(select(MyOrganizationSelectors.GetprojectWorkflowList));
  manageScenarioWorkflow$ = this.store.pipe(
    select(MyOrganizationSelectors.GetManageScenarioWorkflowList)
  );

  productGroupsList$ = this.store.pipe(select(MyOrganizationSelectors.GetProductGroupsList));
  suppliersList$ = this.store.pipe(select(MyOrganizationSelectors.GetSuppliersList));
  litterImpactData$ = this.store.pipe(select(MyOrganizationSelectors.GetlitterImpactData));
  yearEndsOnData$ = this.store.pipe(select(MyOrganizationSelectors.GetyearEndsOnData));
  yearEndsOnDataReplica$ = this.store.pipe(
    select(MyOrganizationSelectors.GetyearEndsOnDataReplica)
  );
  customCategoryData$ = this.store.pipe(select(MyOrganizationSelectors.GetCustomCategoryData));
  customSpeedosData$ = this.store.pipe(select(MyOrganizationSelectors.GetCustomSpeedosData));
  packagingMetricsData$ = this.store.pipe(select(MyOrganizationSelectors.GetPackagingMetricsData));
  projectSavingLogsList$ = this.store.pipe(
    select(MyOrganizationSelectors.GetProjectSavingLogsData)
  );
  ssoGroupList$ = this.store.pipe(select(MyOrganizationSelectors.GetSSOGroupList));
  manageUserDetails$ = this.store.pipe(select(MyOrganizationSelectors.GetUserDetailList));
  manageTeamMembershipDetails$ = this.store.pipe(
    select(MyOrganizationSelectors.GetTeamMembershipList)
  );
  adminOrganizationMembershipDataList$ = this.store.pipe(
    select(MyOrganizationSelectors.GetAdminOrganizationMembershipDataList)
  );
  teamDetails$ = this.store.pipe(select(MyOrganizationSelectors.GetTeamDetailList));
  paymentTransactionList$ = this.store.pipe(
    select(MyOrganizationSelectors.GetPaymentTransactionList)
  );
  invoiceData$ = this.store.pipe(select(MyOrganizationSelectors.GetInvoiceDataList));
  invoiceDownloadData$ = this.store.pipe(select(MyOrganizationSelectors.GetInvoiceDownloadData));
  weightingList$ = this.store.pipe(select(MyOrganizationSelectors.GetWeightingList));
  yearProcessList$ = this.store.pipe(select(MyOrganizationSelectors.addSKUYear));
  skuYearError$ = this.store.pipe(select(MyOrganizationSelectors.GetSKUYearError));
  orgWeightingData$ = this.store.pipe(select(MyOrganizationSelectors.GetOrgWeightingDataList));

  checkUpdateActionSKU$ = this.store.pipe(
    select(MyOrganizationSelectors.checkUpdateActionSKUSelector)
  );

  getManageUsersList(usersPayload: any, pathName: any) {
    this.store.dispatch(
      MyOrganizationActions.getUsersList({ usersPayload: usersPayload, pathName: pathName })
    );
  }

  updateLitterImpactData(eolListItem: any) {
    this.store.dispatch(MyOrganizationActions.updateLitterImpactData({ eolListItem: eolListItem }));
  }

  getManageTeamsList(teamsPayload: any, pathName: any) {
    this.store.dispatch(
      MyOrganizationActions.getManageTeamsList({ teamsPayload: teamsPayload, pathName: pathName })
    );
  }

  openMyOrgDeleteModal(id: any, managetype: any, valueName: any) {
    this.store.dispatch(MyOrganizationActions.openMyOrgDeleteModal({ id, managetype, valueName }));
  }

  deleteManageData(payload: any, managetype: any, valueName: any) {
    this.store.dispatch(MyOrganizationActions.deleteManageData({ payload, managetype, valueName }));
  }

  getprojectWorkflowList(projectWorkflowPayload: any) {
    this.store.dispatch(
      MyOrganizationActions.getProjectWorkflowList({
        projectWorkflowPayload: projectWorkflowPayload,
      })
    );
  }

  getPaymentTransactionList(paymentTransactionPayload: any) {
    this.store.dispatch(
      MyOrganizationActions.getPaymentTransaction({
        paymentTransactionPayload: paymentTransactionPayload,
      })
    );
  }

  getManageScenarioWorkFlowList(manageScenarioWorkflowPayload: any) {
    this.store.dispatch(
      MyOrganizationActions.getManageScenarioWorkflowList({
        manageScenarioWorkflowPayload: manageScenarioWorkflowPayload,
      })
    );
  }
  getProductGroupsList(productGroupsPayload: any) {
    this.store.dispatch(
      MyOrganizationActions.getProductGroupsList({ productGroupsPayload: productGroupsPayload })
    );
  }

  resendConfirmationMail(data: any) {
    this.store.dispatch(MyOrganizationActions.resendConfirmationMail({ emailData: data, url: '' }));
  }

  manualActivateUser(data: any) {
    this.store.dispatch(MyOrganizationActions.manualActivateUser({ emailData: data }));
  }
  getLitterImpactData() {
    this.store.dispatch(MyOrganizationActions.getLitterImpactData());
  }

  getYearEndsOnData() {
    this.store.dispatch(MyOrganizationActions.getYearEndsOnData());
  }

  getSuppliersList(supplierListPayload: any) {
    this.store.dispatch(
      MyOrganizationActions.getSupplierList({ supplierListPayload: supplierListPayload })
    );
  }

  getCustomCategoryList() {
    this.store.dispatch(MyOrganizationActions.getCustomCategoryList());
  }

  getCustomSpeedosData() {
    this.store.dispatch(MyOrganizationActions.getCustomSpeedosData());
  }

  getPackagingMetricsData() {
    this.store.dispatch(MyOrganizationActions.getPackagingMetricsData());
  }

  getProjectSavingLogsList(projectSavingLogsPayload: any) {
    this.store.dispatch(
      MyOrganizationActions.getProjectSavingLogsList({
        projectSavingLogsPayload: projectSavingLogsPayload,
      })
    );
  }

  getSSOGroupLit(ssoGroupPayload: any) {
    this.store.dispatch(
      MyOrganizationActions.getSSOGroupList({ ssoGroupPayload: ssoGroupPayload })
    );
  }

  openAddEditSSOGroupModal(groupId: any, ssoData: any, actionLabel: any) {
    this.store.dispatch(
      MyOrganizationActions.openAddEditSSOGroupModal({
        ssoData: ssoData,
        actionLabel: actionLabel,
        groupId: groupId,
      })
    );
  }

  addEditSSOGroup(data: any) {
    this.store.dispatch(MyOrganizationActions.addEditSSOGroup({ ssoGroupData: data }));
  }

  addManageUser(manageUserData: any) {
    this.store.dispatch(
      MyOrganizationActions.myOrganizationManageUser({
        myOrganizationManageUserData: manageUserData,
      })
    );
  }

  SaveMyOrganizationEditUserForEdit(manageUserData: any) {
    this.store.dispatch(
      MyOrganizationActions.myOrganizationManageUserForEdit({
        myOrganizationManageUserData: manageUserData,
      })
    );
  }

  openAddEditMyOrganizationManageUserModal(
    myOrganizationManageUserId: any,
    actionLabel: any,
    pathName: any
  ) {
    this.store.dispatch(
      MyOrganizationActions.openAddEditMyOrganizationManageUserModal({
        myOrganizationManageUserId: myOrganizationManageUserId,
        actionLabel: actionLabel,
        pathName: pathName,
      })
    );
  }
  openAddEditMyTeamsModal(myTeamsId: any, actionLabel: any, pathName: any) {
    this.store.dispatch(
      MyOrganizationActions.openAddEditMyTeamsModal({
        myTeamsId: myTeamsId,
        actionLabel: actionLabel,
        pathName: pathName,
      })
    );
  }

  addEditMyTeams(data: any) {
    this.store.dispatch(MyOrganizationActions.addEditMyTeams({ myTeamsData: data }));
  }

  openAddEditManageProductGroupModal(managProductGroupId: any, actionLabel: any) {
    this.store.dispatch(
      MyOrganizationActions.openAddEditManageProductsModal({
        manageProductGroupsId: managProductGroupId,
        headerName: actionLabel,
      })
    );
  }

  addEditManageProductGroup(data: any) {
    this.store.dispatch(
      MyOrganizationActions.addEditManageProducts({ manageProductGroupsData: data })
    );
  }

  openAddEditManageProjectWorkFlowModal(manageProjectWorkFlowId: any, actionLabel: any) {
    this.store.dispatch(
      MyOrganizationActions.openAddEditProjectWorkFlowModal({
        manageProjectWorkflowId: manageProjectWorkFlowId,
        headerName: actionLabel,
      })
    );
  }

  addEditManageProjectWorkFlow(data: any) {
    this.store.dispatch(
      MyOrganizationActions.addEditProjectWorkFlow({ manageProjectWorkFlowData: data })
    );
  }

  openAddEditManageScenarioWorkFlowModal(manageScenarioWorkFlowId: any, actionLabel: any) {
    this.store.dispatch(
      MyOrganizationActions.openAddEditScenarioWorkFlowModal({
        manageScenarioWorkflowId: manageScenarioWorkFlowId,
        headerName: actionLabel,
      })
    );
  }

  addEditManageScenarioWorkFlow(data: any) {
    this.store.dispatch(
      MyOrganizationActions.addEditScenarioWorkFlow({ manageScenarioWorkFlowData: data })
    );
  }

  openAddEditSupplierModal(supplierId: any, actionLabel: any) {
    this.store.dispatch(
      MyOrganizationActions.openAddEditSupplierModal({
        supplierId: supplierId,
        headerName: actionLabel,
      })
    );
  }

  addEditSupplier(data: any) {
    this.store.dispatch(MyOrganizationActions.addEditSupplier({ supplierData: data }));
  }

  openEditOrgYearEndModal(orgYearEndId: any, actionLabel: any) {
    this.store.dispatch(
      MyOrganizationActions.openAddEditOrgYearEndModal({
        orgYearEndId: orgYearEndId,
        headerName: actionLabel,
      })
    );
  }

  editSupplier(data: any) {
    // FOR changing YEAR END in PREFERENCES
    this.store.dispatch(MyOrganizationActions.editOrgYearEnd({ orgYearEndData: data }));
  }

  openEditSpeedosModal(customSpeedosId: any, actionLabel: any) {
    this.store.dispatch(
      MyOrganizationActions.openEditCustomSpeedosModal({
        customSpeedosId: customSpeedosId,
        headerName: actionLabel,
      })
    );
  }

  editCustomSpeedo(data: any) {
    this.store.dispatch(MyOrganizationActions.editCustomSpeedos({ customSpeedosData: data }));
  }

  openEditMetricsModal(packagingMetricsId: any, actionLabel: any) {
    this.store.dispatch(
      MyOrganizationActions.openEditPackagingMetricsModal({
        packagingMetricsId: packagingMetricsId,
        headerName: actionLabel,
      })
    );
  }

  editPackagingMetric(data: any) {
    this.store.dispatch(MyOrganizationActions.editpackagingMetrics({ packagingMetricsData: data }));
  }

  openCustomCategoryModal(customCategoryId: any, actionLabel: any) {
    this.store.dispatch(
      MyOrganizationActions.openEditCustomCategoryModal({
        customCategoryId: customCategoryId,
        headerName: actionLabel,
      })
    );
  }

  editCustomCategory(data: any) {
    this.store.dispatch(MyOrganizationActions.editCustomCategory({ customCategoryData: data }));
  }

  openLitterImpactModal(litterImpactId: any, actionLabel: any) {
    this.store.dispatch(
      MyOrganizationActions.openEditLitterImpactModal({
        litterImpactId: litterImpactId,
        headerName: actionLabel,
      })
    );
  }

  editLitterImpact(data: any) {
    this.store.dispatch(MyOrganizationActions.editLitterImpact({ litterImpactData: data }));
  }

  getManageUsersDetailList(manageUserDetailsPayload: any, id: any) {
    this.store.dispatch(
      MyOrganizationActions.getManageUserDetailsList({
        manageUserDetailsPayload: manageUserDetailsPayload,
        id: id,
      })
    );
  }

  getTeamMembershipDetailList(teamMembershipPayload: any, id: any) {
    this.store.dispatch(
      MyOrganizationActions.getManageUserTeamMemberShipGridData({
        manageTeamMembershipPayload: teamMembershipPayload,
        id: id,
      })
    );
  }

  getAdminOrganizationMembershipDetailList(adminOrganozationPayload: any, id: any) {
    this.store.dispatch(
      MyOrganizationActions.getAdminOrganizationMemberShipGridData({
        adminOrganizationMembershipPayload: adminOrganozationPayload,
        id: id,
      })
    );
  }

  getTeamDetailList(teamDetailPayload: any, id: any) {
    this.store.dispatch(
      MyOrganizationActions.getTeamGridData({ manageTeamPayload: teamDetailPayload, id: id })
    );
  }

  openAddEditOrganizationModal(id: any, actionLabel: any, pathName: any) {
    this.store.dispatch(
      MyOrganizationActions.openAddEditOrganizationModal({
        id: id,
        actionLabel: actionLabel,
        pathName: pathName,
      })
    );
  }

  addUpdateOrganizationTeamMembership(data: any) {
    this.store.dispatch(
      MyOrganizationActions.addUpdateOrganizationTeamMembership({
        manageOrganizationTeamData: data,
      })
    );
  }

  openAddEditUsersTeamModal(id: any, userId: any, actionLabel: any) {
    this.store.dispatch(
      MyOrganizationActions.openAddEditUsersTeamMembershipModal({
        id: id,
        userId: userId,
        actionLabel: actionLabel,
      })
    );
  }

  addUpdateUserTeamMembership(data: any) {
    this.store.dispatch(
      MyOrganizationActions.addUpdateUsersTeamMembership({ manageTeamMembershipData: data })
    );
  }

  openAddEditTeamsTeamMembershipModal(id: any, teamId: any, actionLabel: any, orgnizationId?: any) {
    this.store.dispatch(
      MyOrganizationActions.openAddEditTeamsTeamMembershipModal({
        id: id,
        teamId: teamId,
        actionLabel: actionLabel,
        orgnizationId: orgnizationId,
      })
    );
  }

  openAddEditAdminOrganizationMembershipModal(id: any, actionLabel: any, pathName: any) {
    this.store.dispatch(
      MyOrganizationActions.openAddEditAdminOrganizationMembershipModal({
        id: id,
        actionLabel: actionLabel,
        pathName: pathName,
      })
    );
  }

  addUpdateTeamsMembership(data: any) {
    this.store.dispatch(
      MyOrganizationActions.addUpdateTeamMembership({ manageTeamMembershipData: data })
    );
  }

  deleteTeamsTeamMembership(id: any) {
    this.store.dispatch(MyOrganizationActions.deleteTeamsTeamMembership({ id: id }));
  }

  openInvoiceModal(transactionId: any, actionLabel?: any) {
    this.store.dispatch(
      MyOrganizationActions.openInvoiceModal({
        transactionId: transactionId,
        actionLabel: actionLabel,
      })
    );
  }

  invoiceDownloadData(Invoiceid: any) {
    this.store.dispatch(MyOrganizationActions.invoiceDownloadData({ Invoiceid: Invoiceid }));
  }

  openAdminOrgMembershipModal(id: any, userId: any, actionLabel: any) {
    this.store.dispatch(
      MyOrganizationActions.openAddEditAdminManageUserOrgMembershipModal({
        id: id,
        userId: userId,
        actionLabel: actionLabel,
      })
    );
  }

  inlineDataEdit(data: any, module: any, pathName: any, nodeId?: any, field?: any) {
    this.store.dispatch(
      MyOrganizationActions.inlineDataEditForOrganizationPref({
        prefrencesData: data,
        module: module,
        pathName: pathName,
        nodeId: nodeId,
        field: field,
      })
    );
  }

  getOrganizationWeightingList(data: any) {
    this.store.dispatch(MyOrganizationActions.getOrgWeightingsList({ data }));
  }

  addSKUProcessActions(process: any, action: any, processIndex?: any) {
    this.store.dispatch(MyOrganizationActions.addSKUYearProcess({ process, action, processIndex }));
  }

  updateSKUProcessActions(
    process: any,
    action: any,
    processIndex?: any,
    nodeId?: any,
    colId?: any
  ) {
    this.store.dispatch(
      MyOrganizationActions.updateSKUYearProcess({ process, action, processIndex, nodeId, colId })
    );
  }

  deleteSKUProcessActions(process: any, action: any, processIndex?: any) {
    this.store.dispatch(
      MyOrganizationActions.deleteSKUYearProcess({ process, action, processIndex })
    );
  }

  clearStorageProcess() {
    this.store.dispatch(MyOrganizationActions.clearSKUYearProcess());
  }

  patchSKUProcessValue(data: any) {
    this.store.dispatch(MyOrganizationActions.patchDataOnOpenSKUModal({ data }));
  }

  updateWeightingsList(process: any, action: any, processIndex?: any, colId?: any) {
    this.store.dispatch(
      MyOrganizationActions.updateOrgWeightingsList({ process, action, processIndex, colId })
    );
  }

  checkUpdateActionForSKU(check: boolean) {
    this.store.dispatch(MyOrganizationActions.checkUpdateActionSKU({ check }));
  }

  resetWeightingsList(process: any, action: any) {
    this.store.dispatch(MyOrganizationActions.resetWeightingsList({ process, action }));
  }
}
